"use client";

import { useTranslations } from "next-intl";
import { Card, CardContent, CardHeader } from "@repo/ui/components/ui/card";
import SignIn from "@components/sign-in";

export default function Home() {
  const t = useTranslations();

  return (
    <div className="flex items-center justify-center fixed inset-0">
      <Card>
        <CardHeader className="text-center space-y-5 mb-5">
          <p className="text-2xl">{t("title")}</p>
          <p className="text-xl">{t("description")}</p>
        </CardHeader>
        <CardContent className="flex justify-center">
          <SignIn />
        </CardContent>
      </Card>
    </div>
  );
}
